import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

//******************************************************************************
//  NPM (Packages) External
//******************************************************************************
import { SDKLoadingModule } from 'sdk-loading';

//******************************************************************************
//  Services
//******************************************************************************
import { AppSettingsService } from '~/core/services/appsettings.service';
import { GraphService } from '~/core/services/graph.service';
import { FormatterService } from '~/core/services/formatter.service';

//******************************************************************************
//  Pages
//******************************************************************************
import { AuthComponent } from '~/core/pages/auth/auth.component';
import { NotFoundComponent } from '~/core/pages/notfound/notfound.component';

//******************************************************************************
//  Core Components
//******************************************************************************
import { HeaderComponent } from '~/core/components/layout/header/header.component';
import { NavComponent } from '~/core/components/layout/nav/nav.component';
import { FooterComponent } from '~/core/components/layout/footer/footer.component';
import { NavRightComponent } from '~/core/components/layout/nav-right/nav-right.component';
import { AccessComponent } from '~/core/components/access/access.component';
import { AlertComponent } from '~/core/components/alert/alert.component';
import { ErrorComponent } from '~/core/components/error/error.component';
import { NotificationSnackbarComponent } from '~/core/components/notification-snackbar/notification-snackbar.component';

//******************************************************************************
//  Home Page Components
//******************************************************************************
import { ChatInterfaceComponent } from '~/pages/home/chat-interface/chat-interface.component';
import { ChatInputComponent } from '~/pages/home/chat-input/chat-input.component';
import { ExampleQuestionsComponent } from '~/pages/home/example-questions/example-questions.component';
import { DrtParametersTableComponent } from '~/pages/home/drt-parameters-table/drt-parameters-table.component';
import { EwoFilterBarComponent } from '~/pages/home/ewo-filter-bar/ewo-filter-bar.component';

//******************************************************************************
//  Pipes
//******************************************************************************
import { MarkdownPipe } from '~/pages/home/pipes/markdown.pipe';

const components: any[] = [
    HeaderComponent,
    NavComponent,
    NavRightComponent,
    FooterComponent,
    AccessComponent,
    AlertComponent,
    ErrorComponent,
    NotificationSnackbarComponent,

    AuthComponent,
    NotFoundComponent,

    // Home Page Components
    ChatInterfaceComponent,
    ChatInputComponent,
    ExampleQuestionsComponent,
    DrtParametersTableComponent,
    EwoFilterBarComponent,
];

const pipes: any[] = [
    MarkdownPipe,
];

const services: any[] = [
    AppSettingsService,
    GraphService,
    FormatterService,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SDKLoadingModule,
    ],
    declarations: [
        ...components,
        ...pipes,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ...components,
        ...pipes,
    ],
    providers: [
        ...services,
    ],
})

export class CoreImports { }
